import type { ProcessType } from '@/shared/types/common.types';

/** Step identifiers in order. */
export const ONBOARDING_STEPS = [
  'welcome',
  'org_profile',
  'qms_scope',
  'quality_policy',
  'departments',
  'job_roles',
  'processes',
  'invite_team',
  'import_data',
  'quick_setup',
  'done',
] as const;

export type OnboardingStepKey = (typeof ONBOARDING_STEPS)[number];

export const TOTAL_STEPS = ONBOARDING_STEPS.length; // 11

// ---- Step-specific form data ----

export interface OrgProfileFormData {
  name: string;
  industry: string;
  company_size: string;
  timezone: string;
  website: string;
  address: string;
  phone: string;
}

export interface QmsScopeFormData {
  scope_statement: string;
  exclusions: string;
  applicable_sites: string;
}

export interface QualityPolicyFormData {
  policy_statement: string;
  commitments: string[];
}

export interface DepartmentFormData {
  id?: string;
  name: string;
  code: string;
  description: string;
}

export interface JobRoleFormData {
  id?: string;
  name: string;
  department_id: string;
  responsibilities: string;
}

export interface ProcessFormData {
  id?: string;
  name: string;
  type: ProcessType;
  iso_clauses: string[];
}

export interface InviteMemberFormData {
  email: string;
  full_name: string;
  role: 'admin' | 'manager' | 'editor' | 'viewer';
}

/** Summary data for the review step. */
export interface OnboardingReviewData {
  orgConfigured: boolean;
  scopeConfigured: boolean;
  policyConfigured: boolean;
  departmentCount: number;
  roleCount: number;
  processCount: number;
  teamMemberCount: number;
}
